import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import type { SpinnerOptions } from 'spin.js';
import { Spinner as SpinJsSpinner } from 'spin.js';
import styles from './Spinner.module.scss';

interface Props extends SpinnerOptions {
  className?: string;
  animation?:
    | 'spinner-line-fade-default'
    | 'spinner-line-shrink'
    | 'spinner-line-fade-quick'
    | 'spinner-line-fade-more';
}

const Spinner: React.FC<Props> = props => {
  const { className, ...spinnerOptions } = props;

  const myRef = useRef<HTMLSpanElement>(null);
  const mySpinner = useRef<SpinJsSpinner>(new SpinJsSpinner(spinnerOptions));

  useEffect(() => {
    mySpinner.current = new SpinJsSpinner(spinnerOptions);

    if (myRef.current) {
      mySpinner.current.spin(myRef.current);
    }

    const spinner = mySpinner.current;
    return () => {
      if (spinner) {
        spinner.stop();
      }
    };
  }, [spinnerOptions]);

  return (
    <div className={classNames(styles.container, className, 'chromatic-ignore')}>
      <span ref={myRef} />
    </div>
  );
};

Spinner.defaultProps = {
  lines: 11,
  length: 8,
  width: 3,
  radius: 5,
  scale: 0.6,
  animation: 'spinner-line-fade-default',
};

export default Spinner;
